(function() {
  'use strict';

  angular
    .module('app', [
      'ui.router',
      'ui.bootstrap',
      'ngSanitize',
      'ngFileUpload',
      'satellizer',
      'app.profile',
      'app.registrations',
      'app.login',
      'app.terms',
      'app.faqs',
      'ngFlash'

    ]);

})();

(function ()
{
  'use strict';

  angular
  .module('app')
  .factory('rsmdateutils',rsmdateutilsFactory )
  .directive('datedropdowns',datedropdowns);

  /** @ngInject */
  function rsmdateutilsFactory( ) {
      var that = this,
          dayRange = [1, 31],


          months = [{
              value: 0,
              name: 'Janeiro'
          }, {
              value: 1,
              name: 'Fevereiro'
          }, {
              value: 2,
              name: 'Março'
          }, {
              value: 3,
              name: 'Abril'
          }, {
              value: 4,
              name: 'Maio'
          }, {
              value: 5,
              name: 'Junho'
          }, {
              value: 6,
              name: 'Julho'
          }, {
              value: 7,
              name: 'Agosto'
          }, {
              value: 8,
              name: 'Setembro'
          }, {
              value: 9,
              name: 'Outubro'
          }, {
              value: 10,
              name: 'Novembro'
          }, {
              value: 11,
              name: 'Dezembro'
          }];



      function changeDate(date) {
          if (date.day > 28) {
              date.day--;
              return date;
          } else if (date.month > 11) {
              date.day = 31;
              date.month--;
              return date;
          }
      };

      return {
          checkDate: function (date) {
              var d;
              if (!date.day || angular.isUndefined(date.month) || !date.year) return false;

              d = new Date(Date.UTC(date.year, date.month, date.day));

              if (d && (d.getMonth() === date.month && d.getDate() === Number(date.day))) {
                  return d;
              }

              return this.checkDate(changeDate(date));
          },
          days: (function () {
              var days = [];
              while (dayRange[0] <= dayRange[1]) {
                  days.push(dayRange[0]++);
              }
              return days;
          }()),
          months: (function () {

              return months;
          }())
          //months: (function () {
          //    var lst = [],
          //        mLen = months.length;

          //    while (mLen--) {
          //        lst.push({
          //            value: mLen,
          //            name: months[mLen]
          //        });
          //    }
          //    return lst;
          //}())
      };
  }

  /** @ngInject */
  function datedropdowns(rsmdateutils, moment) {
    return {
        restrict: 'A',
        replace: true,
        require: 'ngModel',
        scope: {
            model: '=ngModel'
        },
        controller: ['$scope', 'rsmdateutils', '$filter','$log', function ($scope, rsmDateUtils, $filter, $log) {
            $scope.days = rsmDateUtils.days;
            $scope.months = rsmDateUtils.months;
            $scope.dateFields = {};
            $log.log($scope.model,'date model');
            if($scope.model) {
              var d = moment($scope.model);
              $log.log(d.year(),'year');
              $scope.dateFields.year = d.year();
              $scope.dateFields.month = d.month();
              $scope.dateFields.day = d.date();
            }
            $log.log($scope.dateFields);



            $scope.$watch('model', function (newDate) {

                if (newDate) {
                  $log.log(newDate);
                }
            });

            $scope.checkDate = function () {
                var date = rsmDateUtils.checkDate($scope.dateFields);
                if (date) {
                    $scope.model = moment(date).format("YYYY-MM-DD");
                }
            };
        }],
        templateUrl:'app/directives/birthdate/birthdate.html',
        link: function (scope, element, attrs, ctrl) {
            var currentYear = parseInt(attrs.startingYear, 10) || new Date().getFullYear(),
                numYears = parseInt(attrs.numYears, 10) || 100,
                oldestYear = currentYear - numYears,
                overridable = [
                    'dayDivClass',
                    'dayClass',
                    'monthDivClass',
                    'monthClass',
                    'yearDivClass',
                    'yearClass'],
                required;

            scope.years = [];
            scope.yearText = attrs.yearText ? true : false;

            if (attrs.ngDisabled) {
                scope.$parent.$watch(attrs.ngDisabled, function (newVal) {
                    scope.disableFields = newVal;
                });
            }


            for (var i = currentYear; i >= oldestYear; i--) {
                scope.years.push(i);
            }


        }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.terms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.terms', {
            url      : '/termos',
            views    : {

                'content@': {
                    templateUrl: 'app/terms/index.html',
                    controller : 'PrivacyController as vm'
                }
            }
        })
    }

})();

(function() {
  'use strict';

  angular
    .module('app.terms')
    .controller('PrivacyController', PrivacyController);

  /** @ngInject */
  function PrivacyController($scope,$rootScope,$http,Upload,$state,api,$log,$stateParams,$timeout,$sce,UserService,$uibModal) {
    var vm = this;
    vm.showForm = true
    vm.loading = false
    vm.formSending = false
    vm.showDeleteWarning = false
    vm.showThankyou = false
    vm.form = {
      tos : null
    }
    if($rootScope.currentUser.terms_accepted === 1) {
      vm.form.tos=1;
    }
    api.get('contents/terms').then(function(response) {
      vm.terms = response.data.data;
    })
    vm.backToForm = function() {
      vm.showDeleteWarning =false
      vm.showForm =true
    }
    vm.deleteAccount = function() {
      openPasswordModal('btn-danger','Apagar a conta').result.then(function(response) {
        vm.formSending =true;
        api.post('participants/delete',{password:response}).then(function(response) {
          $rootScope.showAlert('warning','A tua conta foi apagada com sucesso');
          UserService.logout();
        }).catch(function(response) {
          vm.formSending =false;
          if(response.data.message == "INVALID_PASSWORD") {
            $rootScope.showAlert('danger','Palavra-passe inválida.');
          } else {
            $rootScope.showAlert('danger','Houve um erro a apagar a conta. Tente novamente.');
          }
        })

      });
    }
    function showUserData() {
      openPasswordModal('btn-info','Continuar').result.then(function(response) {
        vm.formSending =true;
        api.post('participants/data',{password:response}).then(function(response) {
          vm.formSending =false;
          $rootScope.showAlert('success','Foi-te enviado um email com todos os dados que temos.');
        }).catch(function(response) {
          vm.formSending =false;
          if(response.data.message == "INVALID_PASSWORD") {
            $rootScope.showAlert('danger','Palavra-passe inválida.');
          } else {
            $rootScope.showAlert('danger','Houve um erro. Tente novamente.');
          }
        })

      });
    }

    function openPasswordModal(btnClass, btnText) {
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/terms/modal.html',
        controller: function($uibModalInstance) {
          var vm = this;
          vm.submitClass = btnClass;
          vm.submitText = btnText;
          vm.form = {
            password:''
          }
          vm.passwordValidator = {
            submitHandler:function() {
              $uibModalInstance.close(vm.form.password);
            }
          }
          vm.close = function() {
            $uibModalInstance.dismiss('cancel');
          }
          vm.cancel = function () {
             $uibModalInstance.dismiss('cancel');
           };

        },
        controllerAs: 'vm',

        resolve: {

        }
      });
      return modalInstance;
    }

    vm.tosValidator = {
      submitHandler: function() {
        switch(vm.form.tos) {
          case 1:
            api.put('participants/acceptTOS',{terms_accepted:1}).then(function() {
              vm.formSending =true;
              vm.showForm =false;
              // $rootScope.showAlert('success','A tua resposta foi gravada com sucesso');
              UserService.getUser().then(function() {
                vm.showThankyou =true;
              });
            })
            break;
          case 2:
            $timeout(function() {
              vm.showDeleteWarning =true
              vm.showForm =false
            })
            break;
          case 3:
            showUserData()
            break;
        }
      }
    }
  }


 })();

(function ()
  {
      'use strict';

      angular
          .module('app')
          .service('UserService',UserService);


      /** @ngInject */
      function UserService($rootScope,$state,$auth,api,$q) {
       var vm = this;

       vm.logout = function() {
         $auth.logout();
         $rootScope.currentUser = null;

         $state.go('app.login');
       }

       vm.getUser = function() {
         var d = $q.defer();
          api.users.current()
           .then(function(response){

             $rootScope.currentUser = response.data.data;
             if(!$rootScope.currentUser.picture)
              $rootScope.currentUser.picture = 'assets/img/Fotografia_Inscricao.jpg';
             var u = response.data.data;
             d.resolve();
           }).catch(function() {
             $auth.logout();
              d.reject();
             $state.go('app.login');
           })
           return d.promise;
       }


       vm.scorePassword = function(pass) {
           var score = 0;
           if (!pass)
               return score;

           // award every unique letter until 5 repetitions
           var letters = new Object();
           for (var i=0; i<pass.length; i++) {
               letters[pass[i]] = (letters[pass[i]] || 0) + 1;
               score += 5.0 / letters[pass[i]];
           }

           // bonus points for mixing it up
           var variations = {
               digits: /\d/.test(pass),
               lower: /[a-z]/.test(pass),
               upper: /[A-Z]/.test(pass),
               nonWords: /\W/.test(pass),
           }

           var variationCount = 0;
           for (var check in variations) {
               variationCount += (variations[check] == true) ? 1 : 0;
           }
           score += (variationCount - 1) * 10;

           return parseInt(score);
       }
      }
})();

(function ()
{
    'use strict';

    angular
        .module('app.registrations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.registrations', {
            url      : '/inscricoes',
            views    : {

                'content@': {
                    templateUrl: 'app/registrations/index.html',
                    controller : 'RegistrationsController as vm'
                }
            }
        })
        $stateProvider.state('app.registrations.authorization_file', {
            url      : '/termoresponsabilidade/{uuid}',
            views    : {
              'header@': {
                  templateUrl: 'app/header/nomenu.html',
                  controller:'HeaderController',
                  controllerAs:'vm'
              },
              'content@': {
                  templateUrl: 'app/registrations/authorization_file.html',
                  controller : 'RegistrationsUploadAuthFileController as vm'
              }
            },
            data: {
              guest:true
            }
        })
        $stateProvider.state('app.registrations.form', {
            url      : '/{id}/{year}',
            views    : {

                'content@': {
                    templateUrl: 'app/registrations/form.html',
                    controller : 'RegistrationsFormController as vm'
                }
            }
        })
        $stateProvider.state('app.registrations.cancel', {
            url      : '/cancelar/{id}/{year}',
            views    : {

                'content@': {
                    templateUrl: 'app/registrations/cancel.html',
                    controller : 'RegistrationsCancelController as vm'
                }
            }
        })



    }

})();

(function() {
  'use strict';

  angular
    .module('app.registrations')
    .controller('RegistrationsFormController', RegistrationsFormController)
    .controller('RegistrationsCancelController', RegistrationsCancelController)
    .controller('RegistrationsController', RegistrationsController);

  /** @ngInject */
  function RegistrationsController($scope,$http,$timeout,$stateParams,api,moment,Upload) {
    var vm = this;
    vm.userUpdated = false;
    api.activities.active().then(function(response) {
      vm.activities = response.data.data;
      vm.userUpdated = response.data.meta.user_updated;
    })
  }

  /** @ngInject */
  function RegistrationsFormController($scope,$http,Upload,$state,api,$log,$stateParams,$timeout,$sce) {
    var vm = this;
    vm.registration = { camps_excluded:[] };

    vm.activity_id = $stateParams.id;
    vm.activity_year_id = $stateParams.year;

    vm.registration.activity_id = $stateParams.id;
    vm.registration.activity_year_id = $stateParams.year;

    vm.loading = true;
    vm.loadingTransports = true;
    vm.transports = [];
    vm.loadingTransports = false;

    $http.get(api.baseUrl+'activities/'+$stateParams.id  ).then(function(response) {
      vm.activity = response.data.data;
      vm.activeYear = vm.activity.activeyear.data;
      var registrations =  vm.activeYear.registrations.data;
      var registrationActive = false;
      for(var i=0; i<registrations.length; i++) {
        if(registrations[i].state >= 0) {
          registrationActive = true;
          vm.registration = registrations[i];

          break;
        }
      }
      if( registrationActive ) {
        vm.showForm = false;
        vm.registrationSuccess = true;
      } else {
        vm.registration.preferences = vm.activity.subactivities.data;        
      }

      vm.loading=false;
    }).catch(function() {

    })

    vm.paymentOptions = [
      { value:1, text:"Pagamento inteiro"},
      { value:2, text:"Pagamento parcelado (2x)"}
    ]
    vm.solidaryOptions = [
      { value:0, text:"Não"},
      { value:20, text:"20€"},
      { value:30, text:"30€"},
      { value:40, text:"40€"},
      { value:50, text:"50€"},
      { value:60, text:"60€"},
      { value:70, text:"70€"},
      { value:80, text:"80€"},
      { value:90, text:"90€"},
      { value:100, text:"100€"}
    ]

    vm.moveUp = function(index) {
      vm.registration.preferences.move(index, index-1)
    }
    vm.moveDown = function(index) {
      vm.registration.preferences.move(index, index+1)

    }
    vm.removeFromList = function(index) {
      var item  = vm.registration.preferences[index];
      vm.registration.preferences.splice(index,1);
      vm.registration.camps_excluded.push(item);

    }
    vm.restoreToList = function(index) {
      var item  = vm.registration.camps_excluded[index];
      vm.registration.camps_excluded.splice(index,1);
      vm.registration.preferences.push(item);

    }

    function getReferenceNumber(num) {
      for(var i=0; i<vm.registration.references.data.length; i++) {
        if( vm.registration.references.data[i].reference_number==num)
          return vm.registration.references.data[i];
      }
    }
    vm.getReferenceNumber = getReferenceNumber;

    vm.formSending = false;
    vm.registrationSuccess = false;
    vm.formSent = false;
    vm.showError = false;
    vm.showForm = true;
    vm.registrationValidator = {
      submitHandler : function() {
        vm.formSending = true;
        vm.formSent=false;
        vm.showError = false;
        Upload.upload({
          url:api.baseUrl + 'registrations',
          data: vm.registration
        }).then(function (response) {
          vm.formSending = false;
          vm.formSent=true;
          vm.showForm=false;
          vm.registrationSuccess=true;
          vm.registration = response.data.data;
          // vm.ref1 = getReferenceNumber(1);
          // vm.ref2 = getReferenceNumber(2);
          // vm.ref3 = getReferenceNumber(3);
          // $timeout(function() {
          //   $state.go('app.profile');
          // },2*1000)

        }, function (response) {
          switch(response.data.message) {

            default:
              vm.errorMessage = response.data.message;
          }
          vm.formSending = false;
          vm.registrationSuccess=false;
          vm.formSent = false;
          vm.showError = true;

          vm.showForm = true;

        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            $log.log('progress',progressPercentage);
            vm.uploadProgress = Math.round(progressPercentage);
        });
      }
    }

    $scope.$watch(angular.bind(this, function () {
      return vm.registration.sibling_code;
    }), function (newVal) {
      api.post('participants/code',{sibling_code:newVal}).then(function(response) {
        vm.sibling = response.data.name;
      })
    });

    vm.registrationConfirmValidator = {
      submitHandler : function() {
        vm.formSending = true;
        vm.formSent=false;
        vm.showError = false;
        Upload.upload({
          url:api.baseUrl + 'registrations/'+vm.registration.id,
          data: vm.registration
        }).then(function (response) {
          vm.formSending = false;
          vm.formSent=true;
          vm.showForm=false;
          vm.registrationSuccess=true;
          vm.registration = response.data.data;

        }, function (response) {
          switch(response.data.message) {

            default:
              vm.errorMessage = response.data.message;
          }
          vm.formSending = false;
          vm.registrationSuccess=false;
          vm.formSent = false;
          vm.showError = true;

          vm.showForm = true;

        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            $log.log('progress',progressPercentage);
            vm.uploadProgress = Math.round(progressPercentage);
        });
      }
    }
  }


  /** @ngInject */
  function RegistrationsCancelController($scope,$http,Upload,$state,api,$log,$stateParams,$timeout,$sce) {
    var vm = this;
    vm.registration = {};
    vm.registration.activity_id = $stateParams.id;
    vm.registration.activity_year_id = $stateParams.year;
    vm.loading = true;

    $http.get(api.baseUrl+'activities/'+$stateParams.id  ).then(function(response) {
      vm.activity = response.data.data;
      vm.activeYear = vm.activity.activeyear.data;
      var registrations =  vm.activeYear.registrations.data;
      var registrationActive = false;
      for(var i=0; i<registrations.length; i++) {
        if(registrations[i].state >= 0) {
          registrationActive = true;
          vm.registration = registrations[i];
          break;
        }
      }
      if( registrationActive ) {
        vm.showForm = true;

      } else {
        vm.noActiveRegistrations = true;
        vm.showForm = false;
      }
      vm.loading=false;
    }).catch(function() {

    });



    vm.formSending = false;
    vm.formSent = false;
    vm.showError = false;
    vm.showForm = true;
    vm.cancelationSuccess = false;
    vm.registrationValidator = {
      submitHandler:function() {
        $http.post(api.baseUrl+'registrations/cancel', vm.registration).then(function(response) {
          vm.cancelationSuccess = true;
          vm.showForm = false;
        }).catch(function() {

        })
      }
    }
  }


 })();

(function ()
{
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.profile', {
            url      : '/perfil',
            views    : {

                'content@': {
                    templateUrl: 'app/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            }
        })
        .state('app.profile.edit', {
            url      : '/editar',
            views    : {

                'content@': {
                    templateUrl: 'app/profile/edit.html',
                    controller : 'ProfileEditController as vm'
                }
            }
        })
        .state('app.profile.credentials', {
            url      : '/dadosdeacesso',
            views    : {

                'content@': {
                    templateUrl: 'app/profile/credentials.html',
                    controller : 'ProfileCredentialsController as vm'
                }
            }
        });


    }

})();

(function() {
  'use strict';

  angular
    .module('app.profile')
    .directive('profileCard', ProfileCardDirective)
    .controller('ProfileCredentialsController', ProfileCredentialsController)
    .controller('ProfileEditController', ProfileEditController)
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($scope,$http,$timeout,$stateParams,api,moment,Upload) {
    var vm = this;
    vm.loading = true;
    var genders =[
      {id:1,label:'Masculino'},
      {id:2,label:'Feminino'}
    ];

    vm.getGenderLabel = function(value) {
      if(value ==1) {
        return 'Masculino';
      }
      if( value == 2 )
        return 'Feminino';
      return '';
    }
    vm.getParentLabel = function(p) {
      if(p.parent_type ==1) {
        return 'Pai';
      }
      if( p.parent_type == 2 )
        return 'Mãe';
      if( p.parent_type == 3 )
        return 'Encarregado de educação';
      return '';
    }
    vm.participant = {};
    api.users.participant().then(function(response) {
      vm.participant = response.data.data;
      vm.loading=false;
    });
  }
  /** @ngInject */
  function ProfileEditController($scope,$state,$http,$timeout,$stateParams,api,moment,Upload,$log,UserService) {
    var vm = this;
    vm.loading = true;
    vm.passwordScore = 0;
    vm.defaultPhoto = '';
    vm.requireUploads = false;
    vm.uploadProgress = 0;
    vm.filenames = function(files) {
      if( !files )
        return '';
      var txt ='';
      for(var i=0; i< files.length; i++) {
        txt += files[i].name+", ";
      }
      return txt;
    }
    var genders =[
      {id:1,label:'Masculino'},
      {id:2,label:'Feminino'}
    ];
    vm.parentTypes =[
      {id:1,label:'Pai'},
      {id:2,label:'Mãe'},
      {id:3,label:'Outro'}
    ];
    $.validator.addMethod("strongPassword", function(value, element ) {
        return this.optional( element ) || UserService.scorePassword(value) >= 60;

      }, $.validator.format("Por favor escolha uma palavra passe mais forte."));
    $scope.$watch(
          "vm.participant.user.data.password",
          function handleFooChange( newValue, oldValue ) {
              vm.passwordScore = UserService.scorePassword(newValue)
          }
      );

    vm.addSibling = function() {
      vm.participant.siblings.push("");
    }
    vm.removeSibling = function($index) {
      vm.participant.siblings.splice($index,1);
    }
    vm.getParentLabel = function(p) {
      if(p.parent_type ==1) {
        return 'Pai';
      }
      if( p.parent_type == 2 )
        return 'Mãe';
      if( p.parent_type == 3 )
        return 'Encarregado de educação';
      return '';
    }
    vm.participant = {};
    api.users.participant().then(function(response) {
      vm.participant = response.data.data;
      vm.defaultPhoto = vm.participant.picture?vm.participant.picture:'assets/img/Fotografia_Inscricao.jpg';
      if(!vm.participant.cc_files) {
        vm.requireUploads = true;
      }
      if(vm.participant.siblings.length == 0)
        vm.participant.siblings =[""];
      vm.participant.parentsData = {};
      for(var i=0; i< vm.participant.parents.data.length; i++) {
        vm.participant.parentsData[ vm.participant.parents.data[i].parent_type ] = vm.participant.parents.data[i];
      }

      vm.loading=false;
    });

    vm.profileValidator = {
      rules: {
        gender: "required",
        nif: {
          required:true,
          nifPT:true
        },
        "password": {
          strongPassword:true
        },
        "password_confirm": {
          equalTo:"#password"
        }
      },
      submitHandler : function() {
        vm.formSending = true;
        vm.formSent=false;
        vm.showError = false;
        Upload.upload({
          url:api.baseUrl + 'participants/'+vm.participant.id,
          data: vm.participant
        }).then(function (response) {
          vm.formSending = false;
          vm.formSent=true;
          vm.registration = response.data.data;
          $timeout(function() {
            $state.go('app.profile');
          },2*1000)

        }, function (response) {
          switch(response.data.message) {

            default:
              vm.errorMessage = response.data.message;
          }
          vm.formSending = false;
          vm.formSent = false;
          vm.showError = true;

          vm.showForm = true;

        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            $log.log('progress',progressPercentage);
            vm.uploadProgress = Math.round(progressPercentage);
        });
      }
    }
  }
  /** @ngInject */
  function ProfileCredentialsController($rootScope,$scope,$state,$timeout,$auth,api,moment,UserService) {
    var vm = this;

    vm.passwordScore = 0;
    vm.formErrorMessage = '';
    vm.loading=false;
    vm.userData = {
      username: $rootScope.currentUser.username,
      password:'',
      password_confirm:''
    }

    $.validator.addMethod("strongPassword", function(value, element ) {
        return this.optional( element ) || UserService.scorePassword(value) >= 60;

      }, $.validator.format("Por favor escolha uma palavra passe mais forte."));
    $scope.$watch(
          "vm.userData.password",
          function handleFooChange( newValue, oldValue ) {
              vm.passwordScore = UserService.scorePassword(newValue)
          }
      );

    vm.credentialsValidator = {
      rules: {
        "username": {
          required:true,
          remote: {
            url:api.baseUrl+"users/checkusername",
            headers: { 'Authorization': 'Bearer '+ $auth.getToken() }
          }
        },
        "password": {
          strongPassword:true,
          required:true
        },
        "password_confirm": {
          equalTo:"#password",
          required:true
        }
      },
      submitHandler : function() {
        vm.formSending = true;
        api.users.update(vm.userData).then(function(response) {
          vm.formSending = false;
          vm.formSent=true;
          $rootScope.currentUser = response.data.data;
          $timeout(function() {
            $state.go('app.profile');
          },2*1000);
        }).catch(function(response) {
          vm.formSending = false;
          vm.formSent = false;
          vm.showError = true;
          vm.showForm = true;
          vm.formErrorMessage = response.data.message;
        })

      }
    }
  }

  /** @ngInject */
  function ProfileCardDirective() {
    return {
      restrict: 'A',
      scope: {
        cardLabel: '=',
        cardValue: '=',
      },
      templateUrl:'app/profile/line.html',
      link: function (scope, elem, attr, ctrl) {

      }
    };
  }
 })();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ResetPassController', ResetPassController)
    .controller('SendResetPassController', SendResetPassController)
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($scope,$rootScope,$state,$log,$auth,UserService) {
    var vm = this;
    vm.working= false;
    vm.form = {username:'', password:''};
    vm.loginError = false;
    vm.loginErrorMessage = '';
    vm.loginSuccess = false;
    function login() {
      var user = {
        username: vm.form.username,
        password: vm.form.password,
      }
      $auth.login(user)
        .then(function(response) {
          vm.loginSuccess  =true;
          UserService.getUser().then(function() {
            $state.go('app.home');
          })

        })
        .catch(function(response) {
          vm.loginSuccess  =false;
          vm.loginError  =true;
          switch(response.data.message) {
            case 'invalid_credentials':
              vm.loginErrorMessage = 'Nome de utilizador ou palavra-passe incorrectos';
              break;
            default:
              vm.loginErrorMessage =response.data.message;
              break;
          }
          // Handle errors here, such as displaying a notification
          // for invalid username and/or password.
          $rootScope.currentUser = null;
          vm.working = false;
          $log.log('login error');

        });
    }

    vm.loginValidator = {
      submitHandler: function() {
        vm.working = true;
        vm.loginSuccess  =false;
        vm.loginError  =false;
        login();
      }
    }
  }

  /** @ngInject */
  function SendResetPassController($scope,$rootScope,$state,$log,$http,api) {
    var vm = this;
    vm.working= false;
    vm.sentRecovery= false;
    vm.form = {username:'' };

    function resetPass() {
      api.users.recoverPassword(vm.form).then(function() {
        vm.sentRecovery = true;
      }).catch(function() {
        vm.sentRecovery  =true;
      });
    }

    vm.loginValidator = {
      submitHandler: function() {
        vm.working = true;
        resetPass();
      }
    }
  }

  /** @ngInject */
  function ResetPassController($scope,$rootScope,$state,$log,$stateParams,api,UserService) {
    var vm = this;
    vm.working= false;
    vm.resetSuccess = false;
    vm.resetError = false;
    vm.responseError = 'Erro!';
    vm.form = {username:'', token:$stateParams.token };

    function resetPass() {

      api.users.resetPassword(vm.form).then(function() {
        vm.resetSuccess = true;
      }).catch(function(response) {
        vm.resetError = true;
        vm.responseError = response.data.message;
      })
    }
    $.validator.addMethod("strongPassword", function(value, element ) {
        return this.optional( element ) || UserService.scorePassword(value) >= 60;

      }, $.validator.format("Por favor escolha uma palavra passe mais forte."));

    $scope.$watch(
          "vm.form.password",
          function handleFooChange( newValue, oldValue ) {
              vm.passwordScore = UserService.scorePassword(newValue)
          }
      );

    vm.loginValidator = {
      rules: {
        "password": {
          strongPassword:true,
          required:true
        },
        "password_confirm": {
          required:true,
          equalTo:"#password"
        }
      },
      submitHandler: function() {
        vm.working = true;
        resetPass();
      }
    }
  }

 })();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope, $http, $timeout, $stateParams, api,$auth) {
    var vm = this;
    

    vm.registrations =[];
    if($auth.isAuthenticated()) {
      api.get('registrations').then(function(response) {
        vm.registrations = response.data.data;
      })
    }
    api.get('contents/home').then(function(response) {
      vm.contents = response.data.data;
    })
  }



})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HeaderController', HeaderController);

  /** @ngInject */
  function HeaderController($scope,$rootScope,$stateParams) {
    var vm = this;
    $scope.isNavCollapsed = true;

    // console.log($stateParams)
    // if(angular.isDefined($stateParams.message)) {
    //   vm.message = $stateParams.message;
    // }
  }


 })();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('FormController', FormController);

  /** @ngInject */
  function FormController() {
    var vm = this;
  } 
})();

(function ()
{
    'use strict';

    angular
        .module('app.faqs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.faqs', {
            url      : '/faq',
            views    : {

                'content@': {
                    templateUrl: 'app/faqs/index.html',
                    controller : 'FaqsController as vm'
                }
            },
            data : {
              guest:true
            },
        })




    }

})();

(function() {
  'use strict';

  angular
    .module('app.faqs')
    .controller('FaqsController', FaqsController);

  /** @ngInject */
  function FaqsController($scope,$http,$timeout,$stateParams,api,moment,Upload) {
    var vm = this;
    vm.loading = true;
    api.faqs().then(function(response) {
      vm.loading = false;
      vm.faqs = response.data.data;
    })
  }


 })();

(function ()
{
  'use strict';

  angular
  .module('app')
  .config(config)
  .factory('jqueryValidate',jqueryValidateFactory )
  .provider('$jqueryValidate',jqueryValidateProvider )
  .directive('formvalidator',formvalidator);

  /** @ngInject */
  function jqueryValidateFactory() {
    return $.validator;
  }
  /** @ngInject */
  function jqueryValidateProvider() {
    return {
      setDefaults: function (options) {
        $.validator.setDefaults(options);
      },
      addMethod: function (name, func, errorText) {
        $.validator.addMethod(name, func, errorText);
      },
      $get: function () {
        return {

        }
      }
    }
  }
  /** @ngInject */
  function formvalidator() {
    return {
      restrict: 'A',
      scope: {
        formvalidatorconfig: '=',
        formvalidatorapi: '='
      },
      link: function (scope, elem, attr, ctrl) {
        scope.$watch('formvalidatorconfig', function (value) {
          if (value) {
            elem.validate(value);
            if (value.validateOnInit)
            scope.formvalidatorapi.validate();
          }
        });

        scope.formvalidatorapi = {
          validate: function() {
            elem.validate().form();
          },
          showErrors: function(a) {
            elem.validate().showErrors(a);
          },
          valid: function () {
            return elem.valid();
          }
        };
      }
    };
  }

  /** @ngInject */
  function config($jqueryValidateProvider)
  {
    $jqueryValidateProvider.setDefaults({
      ignore:":hidden:not(.do-not-ignore)",
      errorElement:'span',
      errorPlacement: function(error,element) {
        var ele = angular.element(element);
        if( angular.isDefined(ele.attr('type')) && (ele.attr('type').toLowerCase() == "radio" || ele.attr('type').toLowerCase() == "checkbox" ) ) {
          // error.insertAfter("#lastname");
          ele.parents('.controls:first').append(error);
        } else if(  ele.hasClass('password') )  {
          ele.parents('.controls:first').append(error);
        } else if(  ele.hasClass('group-text') )  {
          ele.parents('.controls:first').append(error);
        } else if(  ele.hasClass('birthdate_field') )  {
          ele.parents('.controls:first').append(error);
        } else {
          error.insertAfter(element);
        }
      }
     });
     $.validator.addMethod( "zipcodePT", function( value, element, params ) {
      return this.optional( element ) || /^\d{4}-\d{3}$/.test( value );
  	}, $.validator.format( "Código postal inválido" ) ) ;

     $.validator.addMethod( "mobile", function( value, element, params ) {
      return this.optional( element ) || /^^([9][12367]\d{7})$/.test( value );
  	}, $.validator.format( "Número de telemóvel inválido" ) ) ;

     $.validator.addMethod( "phone", function( value, element, params ) {
      return this.optional( element ) || /^^(\d{9})$/.test( value );
  	}, $.validator.format( "Número de telefone inválido" ) ) ;

     $.validator.addMethod( "minimumage", function( value, element, params ) {
       var m = moment(value);

       if( m.year() > params.max  )
        return false;
      return true;
  	}, $.validator.format( "Data de nascimento inválida." ) ) ;

    $.validator.addMethod( "maxage", function( value, element, params ) {
       var m = moment(params.birthdate());
       if(params.isPriest)
        return true;
       if( m.year() < params.min && value != 1  )
        return false;
      return true;
  	}, $.validator.format( "Se nasceu antes de 1987, tem de ser chefe de grupo para se poder inscrever" ) ) ;
    
    $.validator.addMethod( "minor", function( value, element, params ) {
       var m = moment(value);
       if( !params.isGroupMember() &&  params.age() < 18)
          return false;
      return true;
  	}, $.validator.format( "Os menores de 18 anos apenas se podem inscrever num grupo." ) ) ;

    $.validator.addMethod("nifPT", function(value ) {
        if(validaContribuinte(value) )
          return true;
        return false;
      }, $.validator.format("Por favor introduza um NIF válido"));

  }



  /** @ngInject */
  function validaContribuinte(contribuinte){
		// algoritmo de validação do NIF de acordo com
		// http://pt.wikipedia.org/wiki/N%C3%BAmero_de_identifica%C3%A7%C3%A3o_fiscal
		if( contribuinte.substr(0,2) == 'PT' )
			contribuinte = contribuinte.substr(2);
		var temErro=0;
		if( contribuinte.length > 9)
			return false;
		if (
		contribuinte.substr(0,1) != '1' && // pessoa singular
		contribuinte.substr(0,1) != '2' && // pessoa singular
		contribuinte.substr(0,1) != '3' && // pessoa singular
		contribuinte.substr(0,2) != '45' && // pessoa singular não residente
		contribuinte.substr(0,1) != '5' && // pessoa colectiva
		contribuinte.substr(0,1) != '6' && // administração pública
		contribuinte.substr(0,2) != '70' && // herança indivisa
		contribuinte.substr(0,2) != '71' && // pessoa colectiva não residente
		contribuinte.substr(0,2) != '72' && // fundos de investimento
		contribuinte.substr(0,2) != '77' && // atribuição oficiosa
		contribuinte.substr(0,2) != '79' && // regime excepcional
		contribuinte.substr(0,1) != '8' && // empresário em nome individual (extinto)
		contribuinte.substr(0,2) != '90' && // condominios e sociedades irregulares
		contribuinte.substr(0,2) != '91' && // condominios e sociedades irregulares
		contribuinte.substr(0,2) != '98' && // não residentes
		contribuinte.substr(0,2) != '99' // sociedades civis

		) { temErro=1;}
		var check1 = contribuinte.substr(0,1)*9;
		var check2 = contribuinte.substr(1,1)*8;
		var check3 = contribuinte.substr(2,1)*7;
		var check4 = contribuinte.substr(3,1)*6;
		var check5 = contribuinte.substr(4,1)*5;
		var check6 = contribuinte.substr(5,1)*4;
		var check7 = contribuinte.substr(6,1)*3;
		var check8 = contribuinte.substr(7,1)*2;
    var comparador;
		var total= check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8;
		var divisao= total / 11;
		var modulo11=total - parseInt(divisao)*11;
		if ( modulo11==1 || modulo11==0){ comparador=0; } // excepção
		else { comparador= 11-modulo11;}


		var ultimoDigito=contribuinte.substr(8,1)*1;
		if ( ultimoDigito != comparador ){ temErro=1;}

		if (temErro==1){ return false }
		return true;
	}



})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state,$auth,api,$log, $urlRouter,UserService,$transitions,Flash) {

    var match = {
      to: function(state) {
        return !$auth.isAuthenticated() && state.name !='app.login' && ! (state.data != null && state.data.guest==true);
      }
    }
    var matchTerms = {
      to: function(state) {
        return $auth.isAuthenticated() && state.name !='app.terms'
                  && ($rootScope.currentUser.terms_accepted !== 1);
      }
    }
    $transitions.onStart( match, function(trans) {
      var $state = trans.router.stateService;
      $state.go('app.login');
    });
    $transitions.onStart( matchTerms, function(trans) {
      var $state = trans.router.stateService;
      console.log($rootScope.currentUser)
      $state.go('app.terms');
    });

   $rootScope.logout= function() {
     UserService.logout();
   }

   $rootScope.showAlert = function (type, message) {
       var id = Flash.create(type, message);
       // First argument (string) is the type of the flash alert.
       // Second argument (string) is the message displays in the flash alert (HTML is ok).
       // Third argument (number, optional) is the duration of showing the flash. 0 to not automatically hide flash (user needs to click the cross on top-right corner).
       // Fourth argument (object, optional) is the custom class and id to be added for the flash message created.
       // Fifth argument (boolean, optional) is the visibility of close button for this flash.
       // Returns the unique id of flash message that can be used to call Flash.dismiss(id); to dismiss the flash message.
   }

    if( $auth.isAuthenticated() ) {
          UserService.getUser()
          .then(function(){
            $log.log('user loaded, proceed');
            // Once permissions are set-up
            // kick-off router and start the application rendering
            $urlRouter.sync();
            // Also enable router to listen to url changes
            $urlRouter.listen();

          });
      } else {
        $log.log('no auth, proceed');
        $urlRouter.sync();
        // Also enable router to listen to url changes
        $urlRouter.listen();
      }


       // Store state in the root scope for easy access
       $rootScope.state = $state;

       Array.prototype.move = function (old_index, new_index) {
          while (old_index < 0) {
              old_index += this.length;
          }
          while (new_index < 0) {
              new_index += this.length;
          }
          if (new_index >= this.length) {
              var k = new_index - this.length;
              while ((k--) + 1) {
                  this.push(undefined);
              }
          }
          this.splice(new_index, 0, this.splice(old_index, 1)[0]);
          return this; // for testing purposes
      };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
        url:'',
        abstract:true,
        views: {
            'header@': {
                templateUrl: 'app/header/header.html',
                controller:'HeaderController',
                controllerAs:'vm'
            },
            'footer@': {
                templateUrl: 'app/footer/footer.html'
            },

        }
      })
      .state('app.home', {
        url:'/',
        views: {
            'content@': {
                templateUrl: 'app/home/home.html',
                controller:'HomeController',
                controllerAs:'vm'
            }

        },      
        data : {
          guest:true
        },
      })
      .state('show', {
        url:'/ver/{uuid}',
        views: {
            'content@': {
                templateUrl: 'app/form/show.html',
                controller:'FormShowController',
                controllerAs:'vm'
            }
        }
      })





    $urlRouterProvider.otherwise('/');
  }


})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('apiURL', 'https://api.inscricoes.carracas.pt/')
    // .constant('apiURL', 'http://api.cf.test/')
    .constant('moment', moment)


})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);


  /** @ngInject */
  function config($logProvider,$locationProvider,$authProvider, apiURL,$sceDelegateProvider,$urlRouterProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true);


    // Put your custom configurations here
    $authProvider.httpInterceptor = function() { return true; },
    $authProvider.withCredentials = true;
    $authProvider.tokenRoot = null;
    $authProvider.baseUrl = apiURL+'/..';
    $authProvider.loginUrl = '/auth/login';
    $authProvider.tokenName = 'token';
    $authProvider.tokenPrefix = 'satellizer';
    $authProvider.authHeader = 'Authorization';
    $authProvider.authToken = 'Bearer';
    $authProvider.storageType = 'localStorage';


    $urlRouterProvider.deferIntercept();

    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'https://s3-eu-west-1.amazonaws.com/**',
      'http://api.carracas.app/**',
      'https://api.inscricoes.carracas.pt/**'
    ]);

    // The blacklist overrides the whitelist so the open redirect here is blocked.
    // $sceDelegateProvider.resourceUrlBlacklist([
    //   'http://myapp.example.com/clickThru**'
    // ]);

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($http,apiURL,$log)
    {

        var api = {};

        // Base Url
        api.baseUrl = apiURL;
        api.get = function(url) {
          return $http.get(api.baseUrl+url);
        }
        api.post = function(url,data) {
          return $http.post(api.baseUrl+url,data);
        }
        api.put = function(url,data) {
          return $http.put(api.baseUrl+url,data);
        }
        api.delete = function(url,data) {
          return $http.delete(api.baseUrl+url,data);
        }
        api.users = {
          current: function() {
            $log.log('getting current user')
            return $http.get(api.baseUrl + 'users/me');

          },
          update: function(data) {
            $log.log('update current user')
            return $http.post(api.baseUrl + 'users/update',data);

          },
          participant: function() {
            $log.log('getting user participant')
            return $http.get(api.baseUrl + 'participants/me');

          },
          recoverPassword: function(data) {
            return $http.post(api.baseUrl + 'auth/sendreset', data);
          },
          resetPassword: function(data) {
            return $http.post(api.baseUrl + 'auth/reset', data);
          }
        }

        api.activities = {
          active: function() {
            return $http.get(api.baseUrl+'activities');
          }
        }
        api.faqs = function() {
            return $http.get(api.baseUrl+'faqs');
        }



        return api;
    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {

                'content@': {
                    templateUrl: 'app/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            data: {
              guest:true
            }
        });
        $stateProvider.state('app.resetpass', {
            url      : '/recuperar-palavra-passe',
            views    : {

                'content@': {
                    templateUrl: 'app/login/reset.html',
                    controller : 'SendResetPassController as vm'
                }
            },
            data: {
              guest:true
            }
        });
        $stateProvider.state('app.newpassword', {
            url      : '/repor-palavra-passe/{token}',
            views    : {

                'content@': {
                    templateUrl: 'app/login/password.html',
                    controller : 'ResetPassController as vm'
                }
            },
            data: {
              guest:true
            }
        });


    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/faqs/index.html","<div class=row><div class=col-sm-9><h1>Perguntas frequentes</h1><div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div ng-if=!vm.loading><uib-accordion close-others=true><div uib-accordion-group class=panel-default heading=\"{{ faq.title }}\" ng-repeat=\"faq in vm.faqs track by $index\"><div ng-bind-html=faq.content></div></div></uib-accordion></div></div></div>");
$templateCache.put("app/footer/footer.html","<footer><div class=container><div class=row><div class=col-xs-4><a class=nomundo href=https://www.nomundo.pt>Desenvolvido por<br><img src=assets/img/EA_Rodape_Logo_noMundo.png class=img-responsive></a></div><div class=\"col-xs-8 text-right\"><a href=https://carracas.pt/index.php/termos target=_blank>Termos e Condições</a></div></div></div></footer>");
$templateCache.put("app/form/form.html","<div class=container><div class=row><div class=\"col-sm-10 col-sm-offset-1\"><h1>Inscrições Peregrinação Eu Acredito</h1><fieldset ng-class=\"{\'closed\':vm.steps.current>1}\"><legend>Dados Pessoais</legend><form ng-if=\"vm.steps.current==1\" formvalidator formvalidatorconfig=vm.step1Validator formvalidatorapi=step1ValidatorAPI><div class=form-group><label class=control-label>Nome completo <span class=required>(*)</span></label><input type=text name=name ng-model=vm.userData.name class=form-control required></div><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Data de Nascimento <span class=required>(*)</span></label><div class=controls><input type=text datedropdowns ng-model=vm.userData.birth_date name=birth_date></div><p class=help-block>Apenas se podem inscrever peregrinos nascidos entre 1987 e 2002, excepto se forem chefes de grupo ou padres/</p><p></p></div><div class=\"form-group col-sm-6\"><label class=control-label>Sexo <span class=required>(*)</span></label><div class=controls><label class=radio-inline><input type=radio name=mf ng-value=1 ng-model=vm.userData.mf><i class=input-helper></i> Masculino</label><label class=radio-inline><input type=radio name=mf ng-value=2 ng-model=vm.userData.mf><i class=input-helper></i> Feminino</label></div></div></div><div class=form-group ng-if=\"vm.userData.mf==1 && vm.userData.age > 18\"><label class=control-label>Padre <span class=required>(*)</span></label><div class=controls><label class=radio-inline><input type=radio name=is_priest ng-model=vm.userData.is_priest ng-value=0><i class=input-helper></i> Não</label><label class=radio-inline><input type=radio name=is_priest ng-model=vm.userData.is_priest ng-value=1><i class=input-helper></i> Sim</label></div></div><div class=btns><button class=\"btn btn-info pull-right\" type=submit>Seguinte <i class=\"fa fa-chevron-right\"></i></button></div></form><div class=info-display ng-if=\"vm.steps.current>1\"><div class=form-group><label class=control-label>Nome completo <span class=required>(*)</span></label><p class=info>{{ vm.userData.name }}</p></div><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Data de Nascimento <span class=required>(*)</span></label><p class=info>{{ vm.userData.birth_date }}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Sexo <span class=required>(*)</span></label><p class=info>{{ vm.userData.mf==1?\'Masculino\':\'Feminino\' }}</p></div></div><div class=form-group ng-if=\"vm.userData.mf==1 && vm.userData.age > 18\"><label class=control-label>Padre <span class=required>(*)</span></label><p class=info>{{ vm.userData.is_priest==1?\'Sim\':\'Não\' }}</p></div></div></fieldset><fieldset ng-if=\"vm.steps.current>=2\" ng-class=\"{\'closed\':vm.steps.current>2}\"><legend>Grupo</legend><form ng-if=\"vm.steps.current==2\" formvalidator formvalidatorconfig=vm.step2Validator formvalidatorapi=step2ValidatorAPI><div class=row ng-if=\"!vm.group_link && vm.userData.age >= 18\"><div class=\"form-group col-sm-6\"><label class=control-label>Chefe de Grupo?</label><div class=controls><div><label class=radio-inline><input type=radio name=group_leader ng-model=vm.userData.group_leader ng-value=1><i class=input-helper></i> Sim</label><label class=radio-inline><input type=radio name=group_leader ng-model=vm.userData.group_leader ng-value=0><i class=input-helper></i> Não</label></div></div></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.age >= 18 && vm.userData.group_leader ==1\"><label class=control-label>Vagas a reservar para o grupo, excluindo o chefe de grupo</label><div class=controls><input type=number step=1 min=2 max=24 name=group_reservations ng-model=vm.userData.group_reservations class=form-control></div></div></div><div class=form-group ng-if=\"!vm.userData.group_leader && vm.userData.age <= 30 && vm.userData.age >= 18\"><label class=control-label>Está a inscrever-se num grupo?</label><div class=controls><div><label class=radio-inline><input type=radio name=is_group ng-value=1 ng-model=vm.userData.is_group><i class=input-helper></i> Sim</label><label class=radio-inline><input type=radio name=is_group ng-value=0 ng-model=vm.userData.is_group><i class=input-helper></i> Não</label></div></div></div><div class=form-group ng-if=\"(vm.userData.is_group && !vm.userData.group_leader && vm.userData.age<=30) || vm.userData.age < 18\"><label class=control-label>Código de Grupo</label><input type=text name=group_code ng-model=vm.userData.group_code class=form-control required><p class=help-block>Introduza o código de grupo que recebeu.</p></div><div class=\"alert alert-warning\" ng-show=\"vm.userData.age > 30   && !vm.userData.group_leader && ! vm.userData.is_priest\">Apenas se podem inscrever peregrinos nascidos entre 1987 e 2002, excepto se forem chefes de grupo ou padres</div><button class=\"btn btn-info\" ng-click=\"vm.steps.current=1;\" type=button><i class=\"fa fa-chevron-left\"></i> Anterior</button> <button class=\"btn btn-info pull-right\" type=submit ng-disabled=\"vm.userData.age>30 && ! (vm.userData.is_priest || vm.userData.group_leader)\">Seguinte <i class=\"fa fa-chevron-right\"></i></button></form><div class=info-display ng-if=\"vm.steps.current>2\"><div class=row ng-if=!vm.userData.group_code><div class=\"form-group col-sm-6\" ng-if=\"vm.userData.age >= 18\"><label class=control-label>Chefe de Grupo?</label><div class=controls><div><p class=info>{{ vm.userData.group_leader==1?\'Sim\':\'Não\' }}</p></div></div></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.age >= 18 && vm.userData.group_leader ==1\"><label class=control-label>Vagas a reservar para o grupo, excluindo o chefe de grupo</label><div class=controls><p class=info>{{ vm.userData.group_reservations }}</p></div></div></div><div class=form-group ng-if=\"!vm.userData.group_leader && vm.userData.age <= 30 && vm.userData.age >= 18\"><label class=control-label>Está a inscrever-se num grupo?</label><div class=controls><div><p class=info>{{ vm.userData.is_group==1?\'Sim\':\'Não\' }}</p></div></div></div><div class=form-group ng-if=\"vm.userData.is_group || vm.userData.age < 18\"><label class=control-label>Código de Grupo</label><p class=info>{{ vm.userData.group_code }}</p></div></div></fieldset><form formvalidator formvalidatorconfig=vm.step3Validator formvalidatorapi=step3ValidatorAPI><fieldset ng-class=\"{\'closed\':vm.steps.current>3}\" ng-if=\"vm.steps.current>=3\"><legend>Dados de identificação</legend><div ng-if=\"vm.steps.current==3\"><div class=row><div class=\"form-group col-sm-4\"><label class=control-label>NIF</label><input type=text name=nif ng-model=vm.userData.nif class=form-control required></div><div class=\"form-group col-sm-4\"><label class=control-label>Nº Cartão de Cidadão</label><input type=text name=cc_number ng-model=vm.userData.cc_number class=form-control required></div><div class=\"form-group col-sm-4\"><label class=control-label>Nº SNS</label><input type=text name=sns_number ng-model=vm.userData.sns_number class=form-control required></div></div><div class=form-group><label class=control-label>Upload do Cartão de Cidadão</label><div class=controls><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" type=button ngf-select ng-model=vm.userData.cc_filename ngf-multiple=true ngf-max-files=2 ngf-max-size=2MB>Escolher ficheiro(s)</button> </span><input type=text class=\"form-control do-not-ignore group-text\" name=cc_filename readonly value=\"{{ vm.filenames( vm.userData.cc_filename ) }}\" placeholder=\"\" ng-required=vm.requireUploads></div><!-- /input-group --></div><!-- /input-group --><p class=help-block>Pode escolher até 2 ficheiros com 2MB cada</p></div></div><div class=info-display ng-if=\"vm.steps.current>3\"><div class=row><div class=\"form-group col-sm-4\"><label class=control-label>NIF</label><p class=info>{{ vm.userData.nif}}</p></div><div class=\"form-group col-sm-4\"><label class=control-label>Nº Cartão de Cidadão</label><p class=info>{{ vm.userData.cc_number}}</p></div><div class=\"form-group col-sm-4\"><label class=control-label>Nº SNS</label><p class=info>{{ vm.userData.sns_number}}</p></div></div><div class=form-group><label class=control-label>Upload do Cartão de Cidadão</label><p class=info>{{ vm.filenames( vm.userData.cc_filename ) }}</p></div></div></fieldset><fieldset ng-class=\"{\'closed\':vm.steps.current>3}\" ng-if=\"vm.steps.current>=3 && vm.userData.age < 18\"><legend>Contactos do encarregado de educação</legend><div ng-if=\"vm.steps.current==3\"><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Nome</label><input type=text name=guardian_name ng-model=vm.userData.guardian_name class=form-control required></div><div class=\"form-group col-sm-6\"><label class=control-label>Email</label><input type=email name=guardian_email ng-model=vm.userData.guardian_email class=form-control required></div><div class=\"form-group col-sm-6\"><label class=control-label>Telefone</label><input type=text name=guardian_phone ng-model=vm.userData.guardian_phone class=form-control required></div><div class=\"form-group col-sm-6\"><label class=control-label>Autorização de participação</label><div class=controls><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" type=button ngf-select ng-model=vm.userData.guardian_authorization ngf-multiple=false>Escolher ficheiro</button> </span><input type=text class=\"form-control do-not-ignore group-text\" name=guardian_authorization readonly value=\"{{ vm.userData.guardian_authorization.name}}\" placeholder=\"\" ng-required=vm.requireUploads></div><!-- /input-group --><p class=help-block><a href=http://media.wix.com/ugd/f0dbf6_ed9b21f96bfd40cabac70cb5d2868203.pdf target=_blank>Descarregue aqui a autorização de participação</a></p></div><!-- /input-group --></div></div></div><div class=info-display ng-if=\"vm.steps.current>3\"><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Nome</label><p class=info>{{ vm.userData.guardian_name}}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Email</label><p class=info>{{ vm.userData.guardian_email}}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Telefone</label><p class=info>{{ vm.userData.guardian_phone}}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Autorização de participação</label><p class=info>{{ vm.userData.guardian_authorization.name}}</p></div></div></div></fieldset><fieldset ng-class=\"{\'closed\':vm.steps.current>3}\" ng-if=\"vm.steps.current>=3\"><legend>Contactos pessoais</legend><div ng-if=\"vm.steps.current==3\"><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Email</label><input type=email name=email ng-model=vm.userData.email class=form-control ng-required=\"vm.userData.age>=18\"></div><div class=\"form-group col-sm-6\"><label class=control-label>Telefone</label><input type=text name=phone ng-model=vm.userData.phone class=form-control ng-required=\"vm.userData.age>=18\"></div></div></div><div class=info-display ng-if=\"vm.steps.current>3\"><div class=row><div class=\"form-group col-sm-6\"><label class=control-label>Email</label><p class=info>{{ vm.userData.email}}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Telefone</label><p class=info>{{ vm.userData.phone}}</p></div></div></div></fieldset><fieldset ng-class=\"{\'closed\':vm.steps.current>3}\" ng-if=\"vm.steps.current>=3\"><legend>Peregrinação</legend><div ng-if=\"vm.steps.current==3\"><div class=row><div class=\"form-group col-sm-6\" ng-if=\"!vm.userData.is_group || vm.userData.age>=18\"><label class=control-label>Transporte:</label><select class=form-control name=transports ng-model=vm.userData.transport ng-options=\"item as item.name for item in vm.formData.transports\" required><option value=\"\">Escolha um</option></select></div><div class=\"form-group col-sm-6\" ng-if=\"!vm.userData.is_group || vm.userData.age>=18\"><label class=control-label>Alojamento:</label><select class=form-control name=accommodations ng-model=vm.userData.accommodation ng-options=\"item as vm.getAccomodationLabel(item)   disable when vm.checkAccommodationDisabled(item) for item in vm.formData.accommodations\" required><option value=\"\">Escolha um</option></select><div class=\"alert alert-warning\" ng-if=vm.showAccommodationWarning>Não existem vagas de alojamento suficientes para o grupo.</div></div><div class=\"form-group col-sm-6\"><label class=control-label>Tamanho da t-shirt:</label><select class=form-control name=tshirt_size ng-model=vm.userData.tshirt_size ng-options=\"item as item.name for item in vm.tshirts\" required><option value=\"\">Escolha um</option></select></div></div><div class=row><div class=\"form-group col-sm-4\"><label class=control-label>Pertenço a:</label><select class=form-control name=belongs_to ng-model=vm.userData.belongs_to required><option value=\"\">Escolha um</option><option value=1>Movimento</option><option value=2>Paróquia</option><option value=3>Outro</option></select></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 2\"><label class=control-label>Diocese:</label><select class=form-control name=diocese ng-model=vm.userData.diocese ng-options=\"item as item.name for item in vm.formData.dioceses\" required><option value=\"\">Escolha uma</option></select></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 2 && vm.userData.diocese.has_parishes\"><label class=control-label>Paróquia:</label><select class=form-control name=parish ng-model=vm.userData.parish ng-options=\"item as item.name for item in vm.formData.parishes\" required><option value=\"\">Escolha uma</option></select></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 1\"><label class=control-label>Movimento:</label><select class=form-control name=movement ng-model=vm.userData.movement ng-options=\"item as item.name for item in vm.formData.movements\" required><option value=\"\">Escolha um</option></select></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 3 || (vm.userData.belongs_to == 2 && vm.userData.diocese.has_parishes == 0) ||  (vm.userData.belongs_to == 1 && vm.userData.movement.other == 1)\"><label class=control-label>Indique qual:</label><input class=form-control type=text name=belongs_other ng-model=vm.userData.belongs_other required></div></div></div><div class=info-display ng-if=\"vm.steps.current>3\"><div class=row><div class=\"form-group col-sm-6\" ng-if=\"!vm.userData.is_group || vm.userData.age>=18\"><label class=control-label>Transporte:</label><p class=info>{{ vm.userData.transport.name}}</p></div><div class=\"form-group col-sm-6\" ng-if=\"!vm.userData.is_group || vm.userData.age>=18\"><label class=control-label>Alojamento:</label><p class=info>{{ vm.userData.accommodation.name}}</p></div><div class=\"form-group col-sm-6\"><label class=control-label>Tamanho da t-shirt:</label><p class=info>{{ vm.userData.tshirt_size.name}}</p></div></div><div class=row><div class=\"form-group col-sm-4\"><label class=control-label>Pertenço a:</label><p class=info ng-if=\"vm.userData.belongs_to==1\">Movimento</p><p class=info ng-if=\"vm.userData.belongs_to==2\">Paróquia</p><p class=info ng-if=\"vm.userData.belongs_to==3\">Outro</p></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 2\"><label class=control-label>Diocese:</label><p class=info>{{ vm.userData.diocese.name}}</p></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 2 && vm.userData.diocese.has_parishes\"><label class=control-label>Paróquia:</label><p class=info>{{ vm.userData.parish.name}}</p></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 1\"><label class=control-label>Movimento:</label><p class=info>{{ vm.userData.movement.name}}</p></div><div class=\"form-group col-sm-4\" ng-if=\"vm.userData.belongs_to == 3 || (vm.userData.belongs_to == 2 && vm.userData.diocese.has_parishes == 0) ||  (vm.userData.belongs_to == 1 && vm.userData.movement.other == 1)\"><label class=control-label>Indique qual:</label><p class=info>{{ vm.userData.belongs_other}}</p></div></div></div></fieldset><div ng-if=vm.showError class=\"alert alert-danger\">{{ vm.errorMessage }}</div><p class=form-control-static>Ao inscrever-me concordo com os <a target=_blank href=http://media.wix.com/ugd/f0dbf6_e6c41d86172340b791ada8b176e57b04.pdf>termos e condições da Peregrinação Eu Acredito</a></p><div class=buttons ng-if=\"vm.steps.current==3\"><button type=button class=\"btn btn-primary btn-info\" ng-click=\"vm.steps.current = 2\"><i class=\"fa fa-chevron-left\"></i> Anterior</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\">Inscrever</button></div></form><div class=\"success alert alert-info\" ng-if=vm.formSending><div class=text-center><h4>A gravar inscrição</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div class=\"success well\" ng-if=vm.formSent><h4>Inscrição gravada com sucesso</h4><div ng-if=\"vm.registration.state == 0 && vm.registration.onhold ==0\"><p>A tua pré-inscrição já foi enviada! Os teus dados de pagamento são:</p><div><dl class=dl-horizontal><dt>Entidade</dt><dd>{{ vm.registration.reference.entity }}</dd><dt>Referência</dt><dd>{{ vm.registration.reference.reference }}</dd><dt>Valor</dt><dd>{{ vm.registration.reference.value }} €</dd><dt>Prazo de pagamento:</dt><dd>{{ vm.registration.reference.expiration_date }}</dd></dl></div><p ng-if=\"vm.registration.group_leader ==0\">Vais receber agora na tua caixa de correio eletrónico um e-mail a confirmar estes dados.<br>Não deixes passar o prazo limite de pagamento!</p><p ng-if=\"vm.registration.group_leader ==1\">Número de vagas pedidas: {{ vm.group_stats.reserved }}<br>Número de pessoas em lista de espera: {{ vm.group_stats.onhold }}</p><p ng-if=\"vm.registration.group_leader ==1\">Vais receber agora na tua caixa de correio eletrónico um e-mail a confirmar estes dados.<br>Não deixes passar o prazo limite de pagamento!</p><p ng-if=\"vm.registration.group_leader ==1\">Quando pagares receberás outro e-mail com a identificação do teu grupo, o link que podes partilhar com os outros membros do grupo e os prazos de submissão das pré-inscrições e de pagamento dos restantes membros. Se deixarem passar estes prazos, as vagas deixarão de ficar cativas para o teu grupo.<br><br>Mesmo que alguns membros do teu grupo estejam em lista de espera, é preciso que se inscrevam para lhes podermos atribuir as próximas vagas que venham a existir.</p></div><div ng-if=\" vm.registration.onhold ==1\"><p>A tua pré-inscrição já foi enviada mas infelizmente ficaste em lista de espera. Logo que apareça uma vaga para ti, voltaremos a contactar-te.</p><p></p></div></div></div></div></div><pre style=display:none>\r\n  {{ vm.userData | json}}\r\n  {{ vm.registration | json}}\r\n\r\n</pre>");
$templateCache.put("app/form/show.html","<div class=container><div class=row><div class=\"col-sm-10 col-sm-offset-1\"><div class=\"text-center alert alert-info\" ng-if=vm.loading><h3>A carregar informações</h3><i class=\"fa fa-spin fa-circle-o-notch fa-4x\"></i></div><div ng-if=!vm.loading><h2>Olá {{ vm.registration.name }}</h2><div ng-if=\"vm.registration.state == 0 && vm.registration.onhold ==0\"><div><h4 class=\"alert alert-warning\">Pré-inscrição por pagar</h4><p>Os teus dados de pagamento são:</p><div><dl class=dl-horizontal><dt>Entidade</dt><dd>{{ vm.registration.reference.entity }}</dd><dt>Referência</dt><dd>{{ vm.registration.reference.reference }}</dd><dt>Valor</dt><dd>{{ vm.registration.reference.value }} €</dd><dt>Prazo de pagamento:</dt><dd>{{ vm.registration.reference.expiration_date }}</dd></dl></div><p ng-if=\"vm.registration.group_leader ==1\">Número de vagas pedidas: {{ vm.registration.group.number_registrations }}<br>Número de pessoas em lista de espera: {{ vm.registration.group.onhold }}</p><p ng-if=\"vm.registration.group_leader ==1\">Vais receber agora na tua caixa de correio eletrónico um e-mail a confirmar estes dados.<br>Não deixes passar o prazo limite de pagamento!</p><p ng-if=\"vm.registration.group_leader ==1\">Quando pagares receberás outro e-mail com a identificação do teu grupo, o link que podes partilhar com os outros membros do grupo e os prazos de submissão das pré-inscrições e de pagamento dos restantes membros. Se deixarem passar estes prazos, as vagas deixarão de ficar cativas para o teu grupo.<br><br>Mesmo que alguns membros do teu grupo estejam em lista de espera, é preciso que se inscrevam para lhes podermos atribuir as próximas vagas que venham a existir.</p></div></div><div ng-if=\"vm.registration.state == 4 && vm.registration.onhold ==0\"><div><h4 class=\"alert alert-success\">Já estás oficialmente inscrit{{ vm.registration.mf ==1?\'o\':\'a\' }} na Peregrinação do Eu Acredito.</h4><p ng-if=\"vm.registration.group_leader ==1\">ID do grupo: {{ vm.registration.group.code }}<br>Link: <a href=\"https://inscricoes.eu-acredito.pt/{{ vm.registration.group.code }}\" target=_blank>https://inscricoes.eu-acredito.pt/{{ vm.registration.group.code }}</a></p><p ng-if=\"vm.registration.group_leader ==1\">Número de vagas pedidas: {{ vm.registration.group.number_registrations }}<br>Número de pessoas em lista de espera: {{ vm.registration.group.onhold }}</p><p ng-if=\"vm.registration.group_leader ==1\">Partilha o ID e o link com todos aqueles que se queiram inscrever como membros do teu grupo mas as vagas que pediste só ficam cativas até ao prazo das pré-inscrições!<br><br>Diz a todos os membros do teu grupo que se inscrevam, mesmo que fiquem em lista de espera, para lhes podermos atribuir as vagas que possam vir a existir.<br><br>A inscrição de cada pessoa que usar o ID ou o link será reencaminhada para o teu grupo.<br><br>Depois de passado o prazo de reserva das vagas qualquer pessoa se pode inscrever no teu grupo (até 25 pessoas no total) usando o ID ou o link, mas a sua entrada vai depender de existirem vagas. Se ficar em lista de espera e mais tarde conseguir uma vaga, está dentro do teu grupo.<br><br></p></div></div><div ng-if=\"vm.registration.state == 4 && vm.registration.onhold ==0 && vm.registration.group_leader ==1\"><table class=\"table table-striped\"><legend>Já inscritos no grupo</legend><thead><tr><th>Nome</th><th>Estado</th><th>Entidade</th><th>Referência</th><th>Valor</th><th>Prazo pagamento</th></tr></thead><tbody><tr ng-repeat=\"member in vm.registration.groupmembers.data\"><td>{{ member.name }}</td><td><span ng-show=\"member.onhold == 1\">Em fila de espera</span> <span ng-show=\"member.onhold == 0 && member.state==0\">Por pagar</span> <span ng-show=\"member.onhold == 0 && member.state==1\">Confirmado</span></td><td><span ng-if=\"member.state==0\">{{ member.reference.entity }}</span></td><td><span ng-if=\"member.state==0\">{{ member.reference.reference }}</span></td><td><span ng-if=\"member.state==0\">{{ member.reference.value }} €</span></td><td><span ng-if=\"member.state==0\">{{ member.reference.expiration_date }}</span></td></tr></tbody></table></div><div class=well ng-if=\" vm.registration.onhold ==1\"><p>A tua pré-inscrição já foi enviada mas infelizmente ficaste em lista de espera. Logo que apareça uma vaga para ti, voltaremos a contactar-te.</p></div></div></div></div></div><pre style=display:none>\r\n  {{ vm.userData | json}}\r\n  {{ vm.registration | json}}\r\n\r\n</pre>");
$templateCache.put("app/header/header.html","<header><div class=container><div class=row><div class=col-xs-6><a href data-ui-sref=app.home><img src=assets/img/Logo_carracas.jpg class=img-responsive></a></div></div></div></header><nav class=\"navbar navbar-default\" ng-if=currentUser><div class=container><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"isNavCollapsed = !isNavCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"collapse navbar-collapse\" id=navbar uib-collapse=isNavCollapsed><ul class=\"nav navbar-nav\"><li ui-sref-active=active class=featured><a href data-ui-sref=app.registrations>Inscrições</a></li><li ui-sref-active=active><a href data-ui-sref=app.profile>Perfil</a></li><li ui-sref-active=active><a href data-ui-sref=app.faqs>Perguntas Frequentes</a></li></ul><p class=\"navbar-text navbar-right\">Olá {{ currentUser.firstName }}!<br><a href data-ui-sref=app.profile.edit><i class=\"fa fa-edit\"></i> Editar perfil</a> | <a href ng-click=logout()><i class=\"fa fa-sign-out\"></i> Terminar sessão</a></p><div class=\"navbar-right greeting\"><a href data-ui-sref=app.profile><div class=profile-thumb ng-style=\"{\'background-image\':\'url(\'+ currentUser.picture+\')\' }\"></div></a></div></div></div></nav><nav class=\"navbar navbar-default\" ng-if=!currentUser><div class=container><div><p class=\"navbar-text navbar-right\"><a href data-ui-sref=app.login class=\"btn btn-primary\"><i class=\"fa fa-sign-in\"></i> Iniciar sessão</a></p></div></div></nav><div class=container><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><flash-message></flash-message></div></div></div>");
$templateCache.put("app/header/nomenu.html","<header><div class=container><div class=row><div class=col-xs-6><a href data-ui-sref=app.home><img src=assets/img/Logo_carracas.jpg class=img-responsive></a></div></div></div></header>");
$templateCache.put("app/home/home.html","<div class=row><div class=col-sm-4><img src=https://s3-eu-west-1.amazonaws.com/cf-carracas/images/Imagem1.jpg><p></p><p><img src=https://s3-eu-west-1.amazonaws.com/cf-carracas/images/Imagem2.jpg></p></div><div class=\"col-sm-8 welcome-text\"><div ng-if=currentUser><div class=whitecard ng-repeat=\"item in vm.registrations track by item.id\"><div class=row><div class=col-sm-4><img ng-src=\"{{ item.activity.data.image_url }}\" class=img-responsive></div><div class=col-sm-8><h2>{{ item.activity.data.name }}</h2><div ng-bind-html=item.activity.data.content></div><button data-ui-sref=\"app.registrations.form( {id: item.activity_id, year:item.activity_year_id} )\" class=\"btn btn-primary btn-lg pull-right\"><span ng-if=\"item.show_result && item.subactivity_id && item.interest_confirmed==0 && item.onhold==0\">Confirmar inscrição</span> <span ng-if=\"!item.show_result || item.interest_confirmed==1 || item.onhold==1 || !item.subactivity_id\">Ver inscrição</span></button></div></div></div></div><div ng-bind-html=vm.contents.content></div></div></div>");
$templateCache.put("app/login/login.html","<div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"welcome-text login-text\"><h1>Bem-vindo à plataforma do Carraças.</h1><p>Se já és um participante do Carraças introduz os teus dados de acesso para acederes à tua conta e ao teu perfil.</p><p>Se só sabes o teu nome de utilizador e precisas de uma nova palavra passe clica em”esqueceu-se da palavra-passe? E segue os passos que te forem indicados.</p><p>Se não sabes nem um nem outro envia um email para: <a href=mailto:pulgas.carracas@carracas.pt>pulgas.carracas@carracas.pt</a> a pedir os dados.</p></div></div></div><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><div class=whitecard><form class=form formvalidator formvalidatorconfig=vm.loginValidator formvalidatorapi=loginValidatorAPI><div class=form-group><label class=control-label>Nome de utilizador</label><input type=text name=username class=form-control ng-model=vm.form.username required></div><div class=form-group><label class=control-label>Palavra-passe</label><input type=password name=password class=form-control ng-model=vm.form.password required></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block\" ng-disabled=vm.working><i class=\"fa fa-sign-in\"></i> Login</button></div><div class=\"alert alert-info\" ng-show=\"vm.working && !vm.loginSuccess\">A iniciar sessão</div><div class=\"alert alert-danger\" ng-show=vm.loginError>{{ vm.loginErrorMessage }}</div><div class=\"alert alert-success\" ng-show=vm.loginSuccess>Sessão iniciada com sucesso.</div><div class=form-group><p><a href data-ui-sref=app.resetpass>esqueceu-se da palavra-passe?</a></p></div></form></div></div></div>");
$templateCache.put("app/login/password.html","<div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"welcome-text login-text\"><h1>Repôr palavra-passe</h1><p>Para repores a palavra-passe utiliza o formulário abaixo</p></div></div></div><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><div class=whitecard><form class=form formvalidator formvalidatorconfig=vm.loginValidator formvalidatorapi=loginValidatorAPI><div ng-show=!vm.resetSuccess><div class=form-group><label class=control-label>Nova palavra passe</label><div class=controls><input type=password id=password name=password class=\"form-control password\" ng-model=vm.form.password><div class=\"progress tiny-progress\"><div class=progress-bar ng-class=\"{ \'progress-bar-danger\': vm.passwordScore < 60, \'progress-bar-warning\': vm.passwordScore > 60 && vm.passwordScore <= 80 , \'progress-bar-success\': vm.passwordScore>80}\" role=progressbar aria-valuenow=\"{{ vm.passwordScore }}\" aria-valuemin=0 aria-valuemax=100 style=\"width: {{ vm.passwordScore }}%\"><span class=sr-only>{{ vm.passwordScore }}</span></div></div></div></div><div class=form-group><label class=control-label>Confirme a nova palavra passe</label><input type=password name=password_confirm class=form-control ng-model=vm.form.password_confirm></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block\" ng-disabled=vm.working><i class=\"fa fa-sign-in\"></i> Enviar</button></div></div><div class=\"alert alert-success\" ng-show=vm.resetSuccess>A sua palavra-passe foi alterada com sucesso.<br><a href data-ui-sref=app.login>Iniciar sessão</a></div><div class=\"alert alert-danger\" ng-show=vm.resetError>{{ vm.responseError }}</div><div class=form-group><p><a href data-ui-sref=app.login>Voltar ao login</a></p></div></form></div></div></div>");
$templateCache.put("app/login/reset.html","<div class=row><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"welcome-text login-text\"><h1>Recuperação de palavra-passe</h1><p>Estás na página de recuperação da palavra-passe.</p><p>Introduz o teu nome de utilizador e envia o pedido (clica em enviar), e segue os indicações pois irás receber no teu email um link para repores a palavra-passe.</p></div></div></div><div class=row><div class=\"col-sm-4 col-sm-offset-4\"><div class=whitecard><form class=form formvalidator formvalidatorconfig=vm.loginValidator formvalidatorapi=loginValidatorAPI><div class=form-group><label class=control-label>Nome de utilizador</label><input type=text name=username class=form-control ng-model=vm.form.username></div><div class=form-group><button type=submit class=\"btn btn-primary btn-block\" ng-disabled=vm.working><i class=\"fa fa-sign-in\"></i> Enviar</button></div><div class=\"alert alert-success\" ng-show=vm.sentRecovery>Foi enviado um email para alteração de palavra passe para os endereços de email associados a este utilizador.<br><a href data-ui-sref=app.login>Iniciar sessão</a></div><div class=form-group><p><a href data-ui-sref=app.login>Voltar ao login</a></p></div></form></div></div></div>");
$templateCache.put("app/menu/menu.html","");
$templateCache.put("app/profile/credentials.html","<div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div class=\"row profile-section\" ng-if=\"vm.loading==false\"><div class=col-sm-3></div><div class=col-sm-6><form class=form formvalidator formvalidatorconfig=vm.credentialsValidator formvalidatorapi=credentialsValidatorAPI><h3>Dados de acesso</h3><div class=\"profile edit\"><div class=form-group><label class=control-label>Nome de utilizador (*)</label><input name=username type=text class=form-control ng-model=vm.userData.username required></div><div class=form-group><label class=control-label>Palavra passe (*)</label><div class=controls><input name=password type=password id=password class=\"form-control password\" ng-model=vm.userData.password><div class=\"progress tiny-progress\"><div class=progress-bar ng-class=\"{ \'progress-bar-danger\': vm.passwordScore < 60, \'progress-bar-warning\': vm.passwordScore >= 60 && vm.passwordScore <= 80 , \'progress-bar-success\': vm.passwordScore>80}\" role=progressbar aria-valuenow=\"{{ vm.passwordScore }}\" aria-valuemin=0 aria-valuemax=100 style=\"width:{{ vm.passwordScore }}%\"><span class=sr-only>{{ vm.passwordScore }}</span></div></div></div></div><div class=form-group><label class=control-label>Repita a palavra passe (*)</label><input name=password_confirm id=password_confirm type=password class=form-control ng-model=vm.userData.password_confirm></div></div><div class=\"alert alert-info text-center\" ng-show=vm.formSending><h4>A atualizar dados de acesso</h4></div><div class=\"alert alert-success text-center\" ng-show=vm.formSent><h4>Dados de acesso atualizados com sucesso</h4></div><div class=\"alert alert-success text-center\" ng-show=vm.formError><h4>Houve um erro ao atualizar os dados</h4><p>{{ vm.formErrorMessage }}</p></div><a href data-ui-sref=app.profile class=\"btn btn-danger btn-lg\"><i class=\"fa fa-chevron-left\"></i> Cancelar edição</a> <button type=submit ng-disabled=vm.formSending class=\"btn btn-success btn-lg pull-right\"><i class=\"fa fa-save\"></i> Gravar</button></form></div><div class=col-sm-3></div></div>");
$templateCache.put("app/profile/edit.html","<div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div class=\"row profile-section\" ng-if=\"vm.loading==false\"><div class=col-sm-3></div><div class=col-sm-6><form class=form formvalidator formvalidatorconfig=vm.profileValidator formvalidatorapi=profileValidatorAPI><h3>Dados Pessoais</h3><div class=\"profile edit\"><div class=form-group><label class=control-label>Nome (*)</label><input name=name type=text class=form-control ng-model=vm.participant.name required></div><div class=form-group><label class=control-label>Apelidos (*)</label><input name=surname type=text class=form-control ng-model=vm.participant.surname required></div><div class=form-group><label class=control-label>Data de Nascimento (*)</label><input name=birth_date type=text datedropdowns ng-model=vm.participant.birth_date></div><div class=form-group><label class=control-label>Sexo (*)</label><div class=controls><div><label class=radio-inline><input type=radio name=gender ng-model=vm.participant.gender ng-value=1><i class=input-helper></i> Masculino</label><label class=radio-inline><input type=radio name=gender ng-model=vm.participant.gender ng-value=2><i class=input-helper></i> Feminino</label></div></div></div></div><h3>Contactos</h3><div class=\"profile edit\"><div class=form-group><label class=control-label>Email (*)</label><input type=email name=email class=form-control ng-model=vm.participant.email required></div><div class=form-group><label class=control-label>Telefone (*)</label><input type=text name=phone class=form-control ng-model=vm.participant.phone required></div></div><h3>Dados de Identificação</h3><div class=\"profile edit\"><div class=form-group><label class=control-label>Nº do Cartão de Cidadão (*)</label><input type=text name=cc_number class=form-control ng-model=vm.participant.cc_number required></div><div class=form-group><label class=control-label>NIF (*)</label><input type=text name=nif class=form-control ng-model=vm.participant.nif required></div><div class=form-group><label class=control-label>Nº SNS (*)</label><input type=text name=sns_number class=form-control ng-model=vm.participant.sns_number required></div></div><div class=\"profile edit\"><div class=form-group><label class=control-label>Encarregado de educação (*)</label><select class=form-control name=guardian ng-model=vm.participant.guardian ng-options=\"item.id as item.label for item in vm.parentTypes\"><option value=\"\">Escolha um</option></select></div></div><div ng-repeat=\"parType in vm.parentTypes track by parType.id\" ng-if=\"parType.id !=3 || vm.participant.guardian == 3\"><h3>{{ parType.label }}</h3><div class=\"profile edit\"><div class=form-group><label class=control-label>Nome <span ng-if=\"vm.participant.guardian == parType.id\">(*)</span></label><input type=text class=form-control name=\"parent_{{ parType.id }}_name\" ng-model=\"vm.participant.parentsData[ parType.id ].name\" ng-required=\"vm.participant.guardian == parType.id\"></div><div class=form-group><label class=control-label>Email <span ng-if=\"vm.participant.guardian == parType.id\">(*)</span></label><input type=email class=form-control name=\"parent_{{ parType.id }}_email\" ng-model=\"vm.participant.parentsData[ parType.id ].email\" ng-required=\"vm.participant.guardian == parType.id\"></div><div class=form-group><label class=control-label>Telefone <span ng-if=\"vm.participant.guardian == parType.id\">(*)</span></label><input type=text class=form-control name=\"parent_{{ parType.id }}_phone\" ng-model=\"vm.participant.parentsData[ parType.id ].phone\" ng-required=\"vm.participant.guardian == parType.id\"></div></div></div><h3>Irmãos</h3><div class=\"profile edit\"><div class=form-group ng-repeat=\"sibling in vm.participant.siblings track by $index\"><label class=control-label>Irmã(o)</label><input type=text class=form-control name=\"sibling_{{ $index }}\" ng-model=vm.participant.siblings[$index]></div><button type=button ng-click=vm.addSibling() class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Irmã(o)</button></div><div class=\"alert alert-info text-center\" ng-show=vm.formSending><h4>A atualizar perfil</h4><div class=progress><div class=\"progress-bar progress-bar-info\" role=progressbar aria-valuenow=\"{{ vm.uploadProgress }}\" aria-valuemin=0 aria-valuemax=100 style=\"width: {{ vm.uploadProgress }}%\"><span class=sr-only>{{ vm.uploadProgress }}</span></div></div></div><div class=\"alert alert-success text-center\" ng-show=vm.formSent><h4>Perfil atualizado com sucesso</h4></div><div class=\"alert alert-danger text-center\" ng-show=vm.showError><h4>Houve um erro a atualizar os seus dados</h4><p>{{ vm.errorMessage }}</p></div><button type=submit ng-disabled=vm.formSending class=\"btn btn-success btn-lg\"><i class=\"fa fa-save\"></i> Gravar</button></form></div><div class=col-sm-3><a href data-ui-sref=app.profile class=\"btn btn-danger btn-block sidenav\"><i class=\"fa fa-edit\"></i> Cancelar edição</a></div></div>");
$templateCache.put("app/profile/line.html","<div class=row><div class=\"col-sm-4 display-label\">{{ cardLabel }}</div><div class=\"col-sm-8 display-info\">{{ cardValue }}</div></div>");
$templateCache.put("app/profile/profile.html","<div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div class=\"row profile-section\" ng-if=\"vm.loading==false\"><div class=col-sm-3></div><div class=col-sm-6><h3>Dados de acesso <a href data-ui-sref=app.profile.credentials class=\"btn btn-xs btn-info pull-right\"><i class=\"fa fa-edit\"></i> Editar dados de acesso</a></h3><div class=profile><div class=info-block profile-card card-label=\"\'Nome de utilizador\'\" card-value=vm.participant.user.data.username></div><div class=info-block profile-card card-label=\"\'Palavra passe\'\" card-value=\"\'*****************\'\"></div></div><h3>Dados Pessoais <a href data-ui-sref=app.profile.edit class=\"btn btn-xs btn-info pull-right\"><i class=\"fa fa-edit\"></i> Editar perfil</a></h3><div class=profile><div class=info-block profile-card card-label=\"\'Nome\'\" card-value=vm.participant.name></div><div class=info-block profile-card card-label=\"\'Apelidos\'\" card-value=vm.participant.surname></div><div class=info-block profile-card card-label=\"\'Data de Nascimento\'\" card-value=vm.participant.birth_date></div><div class=info-block profile-card card-label=\"\'Sexo\'\" card-value=vm.getGenderLabel(vm.participant.gender)></div></div><h3>Contactos</h3><div class=profile><div class=info-block profile-card card-label=\"\'Email\'\" card-value=vm.participant.email></div><div class=info-block profile-card card-label=\"\'Telefone\'\" card-value=vm.participant.phone></div></div><h3>Dados de Identificação</h3><div class=profile><div class=info-block profile-card card-label=\"\'Nº Cartão de Cidadão\'\" card-value=vm.participant.cc_number></div><div class=info-block profile-card card-label=\"\'NIF\'\" card-value=vm.participant.nif></div><div class=info-block profile-card card-label=\"\'Nº SNS\'\" card-value=vm.participant.sns_number></div></div><div ng-repeat=\"par in vm.participant.parents.data track by par.id\"><h3>{{ vm.getParentLabel(par) }}</h3><div class=profile><div class=info-block profile-card card-label=\"\'Nome\'\" card-value=par.name></div><div class=info-block profile-card card-label=\"\'Email\'\" card-value=par.email></div><div class=info-block profile-card card-label=\"\'Telefone\'\" card-value=par.phone></div></div></div><h3>Irmãos</h3><div class=profile><div class=info-block profile-card card-label=\"\'Irmã(o)\'\" card-value=sibling ng-repeat=\"sibling in vm.participant.siblings track by $index\"></div></div></div><div class=col-sm-3><div class=sidenav><div class=alert ng-class=\"{\'alert-danger\':!vm.participant.user_updated ,\'alert-success\':vm.participant.user_updated }\">{{ vm.participant.user_updated_at }}</div><a href data-ui-sref=app.profile.edit class=\"btn btn-info btn-block\"><i class=\"fa fa-edit\"></i> Editar perfil</a> <a href data-ui-sref=app.terms class=\"btn btn-default btn-block\"><i class=\"fa fa-handshake-o\"></i> Termos e condições</a></div></div></div>");
$templateCache.put("app/registrations/authorization_file.html","<div class=row><div class=col-sm-9><div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div ng-if=!vm.loading><div class=form ng-if=vm.showForm><form class=form formvalidator formvalidatorconfig=vm.registrationValidator formvalidatorapi=registrationValidatorAPI><div class=\"whitecard block\"><h3>Olá {{ vm.registration.participant.data.name }}</h3><p>Faz aqui o upload do Termo de Responsabilidade para a Peregrinação Carraças 2017.</p></div><div class=block><div class=form-group><label class=control-label>Upload do Termo de responsabilidade (*)</label><div class=controls><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" ngf-model-invalid=vm.invalidFiles type=button ngf-select ng-model=vm.registration.parents_authorization ngf-multiple=false ngf-max-files=1 ngf-max-size=2MB>Escolher ficheiro</button> </span><input type=text class=\"form-control do-not-ignore group-text\" name=parents_authorization readonly value=\"{{ vm.registration.parents_authorization.name  }}\" placeholder=\"\" required></div><!-- /input-group --></div><!-- /input-group --><div class=error ng-if=\"vm.invalidFiles.$error == \'maxSize\'\">O ficheiro tem mais de 2MB</div><p class=help-block>O ficheiro pode ter no máximo até 2MB, e deve ser nos formatos: jpg, png, pdf.<br></p></div><div class=form-group><uib-progressbar class=\"progress-striped active\" max=100 value=vm.uploadProgress type=info><i>{{vm.uploadProgress}} %</i></uib-progressbar></div><div class=form-group><button type=submit ng-disabled=vm.formSending class=\"btn btn-success btn-lg\"><i class=\"fa fa-save\"></i> Inscrever-me</button></div></div></form></div><div class=whitecard ng-show=vm.uploadSuccess><h2>Olá {{ vm.registration.participant.data.name }}</h2><p>O teu termo de responsabilidade foi gravado com sucesso.</p></div><div class=\"alert alert-danger\" ng-show=vm.registrationError><p>Não foi possível encontrar a tua inscrição</p></div></div></div></div>");
$templateCache.put("app/registrations/cancel.html","<div class=row><div class=col-sm-9><div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div ng-if=!vm.loading><div class=\"whitecard activity_info\"><div class=row><div class=col-sm-4><img src=assets/img/25.jpg class=img-responsive></div><div class=col-sm-8><h2>{{ vm.activity.name }}</h2><div ng-bind-html=vm.activeYear.content></div></div></div></div><div class=form ng-if=vm.showForm><form class=form formvalidator formvalidatorconfig=vm.registrationValidator formvalidatorapi=registrationValidatorAPI><div class=\"whitecard block\"><p>Para cancelares usa o formulário abaixo. Atenção que é irreversível!</p></div><div class=block><div class=form-group><label>Razão da desistência</label><div class=controls><textarea name=reason ng-model=vm.registration.reason class=form-control required></textarea></div></div><div class=form-group ng-if=\"vm.registration.state==1\"><label>IBAN</label><div class=controls><input type=text name=iban ng-model=vm.registration.iban class=form-control required></div><p class=help-block>Indica o teu IBAN para que possamos proceder à devolução do pagamento, de acordo ao que está definido nos termos e condições da inscrição.</p></div><div class=form-group><div class=controls><div class=checkbox><label><input type=checkbox value=1 name=optin required> <strong>Sim, compreendo que ao cancelar a inscrição estou a abdicar da minha vaga!</strong></label></div></div></div><div class=form-group><button type=submit ng-disabled=vm.formSending class=\"btn btn-danger btn-lg btn-right\"><i class=\"fa fa-ban\"></i> Cancelar inscrição</button></div></div></form></div><div class=whitecard ng-if=\"vm.cancelationSuccess && vm.registration.state!=1\"><strong>A tua pré-inscrição foi cancelada e abdicaste assim da tua vaga.</strong><br>Se quiseres voltar a inscrever-te deves fazer uma nova inscrição.</div><div class=whitecard ng-if=\"vm.cancelationSuccess && vm.registration.state==1\"><p><strong>A tua inscrição foi cancelada e abdicaste assim da tua vaga.</strong></p><p>Iremos proceder de acordo ao que está definido nos termos e condições da inscrição. Contactaremos em breve.</p><p>Se quiseres voltar a inscrever-te deves fazer uma nova inscrição.</p></div><div class=whitecard ng-if=vm.noActiveRegistrations><p>Não tens inscrições activas para cancelar</p></div></div></div><div class=col-sm-3><div ng-include=\"\'app/menu/menu.html\'\"></div></div></div>");
$templateCache.put("app/registrations/form.html","<div class=row><div class=col-sm-9><div class=loading ng-if=\"vm.loading || vm.loadingTransports\"><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div ng-if=\"!vm.loading  && !vm.loadingTransports\"><div class=\"whitecard activity_info\"><div class=row><div class=col-sm-4><img ng-src=\"{{ vm.activeYear.image_url }}\" class=img-responsive></div><div class=col-sm-8><h2>{{ vm.activity.name }}</h2><div ng-bind-html=vm.activeYear.content></div></div></div></div><div class=form ng-if=\"vm.showForm && vm.activeYear.can_register\"><form class=form formvalidator formvalidatorconfig=vm.registrationValidator formvalidatorapi=registrationValidatorAPI><div class=block><div class=row ng-if=\"vm.registration.preferences.length>1\"><div class=\"form-group col-sm-6\"><label class=control-label>Campo por ordem de preferência</label><table class=table><tr ng-repeat=\"item in vm.registration.preferences  track by item.id\"><td>{{$index+1}}º</td><td>{{ item.name }}</td><td><a title=\"mover para cima\" href ng-click=vm.moveUp($index)><i class=\"fa fa-arrow-up\" ng-if=!$first></i></a></td><td><a title=\"mover para baixo\" href ng-click=vm.moveDown($index)><i class=\"fa fa-arrow-down\" ng-if=!$last></i></a></td><td><a title=\"remover dos preferidos\" href ng-click=vm.removeFromList($index) ng-if=\"!($first && $last)\"><i class=\"fa fa-close\"></i></a></td></tr></table><p class=help-block>Ordena os campos conforme a tua preferência.<br>Caso não possas mesmo nalgumas datas, podes remover os campos dessas datas clicando no <i class=\"fa fa-close\"></i></p></div><div class=\"form-group col-sm-6\"><label class=control-label>Campos que não me quero inscrever</label><table class=table><tr class=warning ng-repeat=\"item in vm.registration.camps_excluded  track by item.id\"><td>{{ item.name }}</td><td><a title=\"repor nos preferidos\" href ng-click=vm.restoreToList($index)><i class=\"fa fa-undo\"></i></a></td></tr></table><div ng-if=\"vm.registration.camps_excluded.length==0\">Não tens campos excluídos</div><p class=help-block>Os campos nesta lista não vão ser utilizados na tua inscrição</p></div></div><p>Ao inscrever-me concordo com os <a href=https://carracas.pt/index.php/termos target=_blank>termos e condições</a></p><div class=form-group><button type=submit ng-disabled=vm.formSending class=\"btn btn-success btn-lg\"><i class=\"fa fa-save\"></i> Inscrever-me</button></div></div></form></div><div class=whitecard ng-show=vm.registrationSuccess><div ng-if=\"vm.registration.show_result == 0\"><div ng-include=\"\'app/registrations/states/new.html\'\"></div><p style=margin-top:20px>Para cancelares a tua inscrição, <a href data-ui-sref=\"app.registrations.cancel({id: vm.activity_id, year:vm.activity_year_id})\">clica aqui</a></p></div><div ng-if=\"vm.registration.show_result ==1\"><div ng-if=\"vm.registration.state == 0\"><div ng-include=\"\'app/registrations/states/new.html\'\" ng-if=\"!vm.registration.subactivity_id && !vm.registration.onhold==1\"></div><div ng-include=\"\'app/registrations/states/onhold.html\'\" ng-if=\"vm.registration.onhold == 1\"></div><div ng-include=\"\'app/registrations/states/interest.html\'\" ng-if=\"vm.registration.subactivity_id && vm.registration.interest_confirmed==0\"></div><div ng-include=\"\'app/registrations/states/payment.html\'\" ng-if=\"vm.registration.subactivity_id && vm.registration.interest_confirmed==1\"></div><p style=margin-top:20px>Para cancelares a tua inscrição, <a href data-ui-sref=\"app.registrations.cancel({id: vm.activity_id, year:vm.activity_year_id})\">clica aqui</a></p></div><div ng-if=\"vm.registration.state == 1\"><div ng-include=\"\'app/registrations/states/confirmed.html\'\"></div><p>Para cancelares a tua inscrição, <a href data-ui-sref=\"app.registrations.cancel({id: vm.activity_id, year:vm.activity_year_id})\">clica aqui</a></p></div></div></div></div></div><div class=col-sm-3><div ng-include=\"\'app/menu/menu.html\'\"></div></div></div>");
$templateCache.put("app/registrations/index.html","<div class=\"row activities\"><div class=col-sm-9><div class=whitecard ng-class=\"{disabled: !item.canRegister}\" ng-repeat=\"item in vm.activities | orderBy:\'-canRegister\' track by item.id\"><div class=row><div class=col-sm-4><img ng-src=\"{{ item.image_url }}\" class=img-responsive></div><div class=col-sm-8><h2>{{ item.name }}</h2><div ng-bind-html=item.content></div><div class=\"alert alert-info\" ng-show=\"!item.activeyear.data.is_registered && !item.canRegister && vm.userUpdated && !item.registration_open\">As inscrições estão encerradas</div><div class=\"alert alert-info\" ng-show=\"!item.activeyear.data.is_registered && !item.canRegister && vm.userUpdated && item.registration_open\">Não cumpre os requisitos para se poder inscrever</div><div class=\"alert alert-info\" ng-show=!vm.userUpdated>Tem de atualizar o seu perfil para se poder inscrever</div><button ng-if=\"vm.userUpdated && item.activeyear.data.is_registered\" data-ui-sref=\"app.registrations.form( {id: item.id, year:item.activeyear.data.id} )\" class=\"btn btn-primary btn-lg pull-right\">Ver inscrição</button> <button ng-if=\"vm.userUpdated  && !item.activeyear.data.is_registered\" ng-disabled=!item.canRegister data-ui-sref=\"app.registrations.form( {id: item.id, year:item.activeyear.data.id} )\" class=\"btn btn-primary btn-lg pull-right\">Inscrever</button> <button ng-if=\"!vm.userUpdated \" data-ui-sref=app.profile class=\"btn btn-primary btn-lg pull-right\">ir para o perfil</button></div></div></div></div><div class=col-sm-3><div ng-include=\"\'app/menu/menu.html\'\"></div></div></div>");
$templateCache.put("app/terms/index.html","<div class=row><div class=col-sm-9><div class=loading ng-if=vm.loading><div class=\"alert alert-info text-center\"><h4>A carregar informação</h4><i class=\"fa fa-circle-o-notch fa-spin fa-4x\"></i></div></div><div ng-if=!vm.loading><div class=form ng-if=vm.showForm><form class=form formvalidator formvalidatorconfig=vm.tosValidator formvalidatorapi=registrationValidatorAPI><div class=\"whitecard block\"><h3>Olá {{ currentUser.name}}</h3><p>Bem vindo à página das inscrições dos Campos 2018!</p><p>Para continuares este processo, pedimos que aceites os Termos e Condições dos Carraças.</p><div ng-bind-html=vm.terms.content></div><div class=form-group><label class=control-label>Aceito os termos e condições do Carraças</label><div class=controls><div><label class=radio-inline><input type=radio name=tos ng-model=vm.form.tos ng-value=1><i class=input-helper></i> Sim</label><label class=radio-inline><input type=radio name=tos ng-model=vm.form.tos ng-value=2><i class=input-helper></i> Não</label><label class=radio-inline><input type=radio name=tos ng-model=vm.form.tos ng-value=3><i class=input-helper></i> Quero ver os Dados que o Carraças tem sobre mim</label></div></div></div><div class=form-group><button type=submit ng-if=\"vm.form.tos === 1\" ng-disabled=vm.formSending class=\"btn btn-success\"><i class=\"fa fa-save\" ng-show=!vm.formSending></i><i class=\"fa fa-spin fa-spinner\" ng-show=vm.formSending></i> Gravar</button> <button type=submit ng-if=\"vm.form.tos !== 1\" ng-disabled=vm.formSending class=\"btn btn-success\"><i class=\"fa fa-save\" ng-show=!vm.formSending></i><i class=\"fa fa-spin fa-spinner\" ng-show=vm.formSending></i> Continuar</button></div></div></form></div><div class=whitecard ng-show=vm.showDeleteWarning><h2>{{ currentUser.name }} a tua conta será apagada</h2><p><strong>Ao não aceitares</strong> os Termos e Condições recordamos que de acordo com o Regime Geral de Protecção de Dados, <strong>todos os teus dados serão eliminados da nossa base de dados, sem possibilidade de recuperação.</strong></p><p>Se for o caso de só não quereres participar este ano, deverás aceitar os Termos e Condições, garantindo que nos próximos anos receberás informação sobre as nossas actividades.</p><button type=button ng-disabled=vm.formSending ng-click=vm.backToForm() class=\"btn btn-default\">Voltar atrás</button> <button type=button ng-disabled=vm.formSending ng-click=vm.deleteAccount() class=\"btn btn-danger pull-right\"><i class=\"fa fa-spin fa-spinner\" ng-show=vm.formSending></i> Cancelar a minha conta</button></div><div class=whitecard ng-show=vm.showThankyou><p>Obrigado {{ currentUser.name }} por teres aceite os nossos Termos e Condições.</p><p>Agora basta que verifiques se os teus dados estão atualizados em \"Perfil\" e terminar a sessão.</p></div><div class=\"alert alert-danger\" ng-show=vm.registrationError><p>Não foi possível encontrar a tua inscrição</p></div></div></div></div>");
$templateCache.put("app/terms/modal.html","<form class=form formvalidator formvalidatorconfig=vm.passwordValidator formvalidatorapi=passwordValidatorAPI><div class=modal-header><h3 class=modal-title id=modal-title>Necessário palavra-passe</h3></div><div class=modal-body id=modal-body><p>Por motivos de segurança, introduz a tua palavra-passe</p><div class=form-group><label class=control-label>Palavra-passe</label><input type=password name=password class=form-control ng-model=vm.form.password required></div></div><div class=modal-footer><button class=\"btn btn-default pull-left\" type=button ng-click=vm.close()>Cancelar</button> <button class=btn ng-class=vm.submitClass type=submit>{{vm.submitText}}</button></div></form>");
$templateCache.put("app/directives/birthdate/birthdate.html","<div class=birthdate-fields><div class=form-inline><select disable-search=true name=dateFields_day data-ng-model=dateFields.day class=\"form-control birthdate_field\" ng-options=\"day for day in days\" ng-change=checkDate() ng-disabled=disableFields required><option value=\"\">Dia</option></select><span class=form-control-static>/</span><select disable-search=true name=dateFields_month data-ng-model=dateFields.month class=\"form-control birthdate_field\" ng-options=\"month.value as month.name for month in months\" value=\"{{ dateField.month }}\" ng-change=checkDate() ng-disabled=disableFields required><option value=\"\">Mês</option></select><span class=form-control-static>/</span><select disable-search=true name=dateFields_year data-ng-model=dateFields.year class=\"form-control birthdate_field\" ng-options=\"year for year in years\" ng-change=checkDate() ng-disabled=disableFields required><option value=\"\">Ano</option></select></div><input type=hidden class=do-not-ignore name=dateFields.birthdate value=\"{{ model }}\" required></div>");
$templateCache.put("app/registrations/states/confirmed.html","<h3>O teu pagamento foi efetuado, a tua vaga está confirmada.</h3><p>Receberás em breve uma carta do campo, com todos os detalhes e indicações práticas (local, material, partida, chegada, documentos necessários, tudo, tudo)</p>");
$templateCache.put("app/registrations/states/interest.html","<form class=form formvalidator formvalidatorconfig=vm.registrationConfirmValidator formvalidatorapi=registrationConfirmValidatorAPI><p ng-if=\"vm.registration.onhold || !vm.registration.subactivity_id\">A tua inscrição está em espera</p><div ng-if=\"vm.registration.onhold ==0 && vm.registration.subactivity_id\"><h3>Tiveste vaga no campo {{ vm.registration.subactivity.data.name }}</h3><h4>Desconto de família</h4><p>Para beneficiar do desconto para irmãos: inscrever o 1º irmão normalmente e nas inscrições dos restantes irmãos, indicar o código de família.</p><div class=form-group><label class=control-label>Código de família</label><div class=\"controls row\"><div class=col-sm-2><input type=text ng-model-options=\"{ debounce: 1500 }\" name=sibling_code ng-model=vm.registration.sibling_code class=form-control></div><div class=col-sm-10><input type=text name=sibling_name disabled readonly ng-model=vm.sibling class=form-control></div></div><p class=\"help-block danger\">Se colocares um código de alguém que não é teu irmão, a tua inscrição será cancelada</p></div><div><button type=submit class=\"btn btn-primary\">Confirmar</button></div></div></form>");
$templateCache.put("app/registrations/states/new.html","<h3>Recebemos a tua inscrição!</h3><p>Agora vais ter que esperar até te dizermos se tens vaga.</p><p>Campos para que te inscreveste:</p><ol><li ng-repeat=\"pref in vm.registration.preferences track by $index\">{{pref.name}}</li></ol>");
$templateCache.put("app/registrations/states/onhold.html","<p>Pois é…temos muita pena, mesmo muita pena, acredita, mas infelizmente não temos boas notícias para te dar…</p><p>Este ano o número de inscrições voltou a ultrapassar em muito todas as nossas expectativas, pelo que não conseguimos levar todos os que se candidataram…e tu és um deles.</p><p>Temos muita pena por não te podermos dizer que entraste, mas confiamos e esperamos que não vás desistir já, pois até ao dia da partida pode haver desistências e estás em lista de espera!</p><p>Senão, ... esperamos que não desistas de nós e que para o ano te tornes a inscrever pois, se Deus quiser, haverá mais PULGAS, CARRAÇAS & CARRAÇÕES! e durante o ano iremos desafiar-te para as atividades que vamos organizando, onde serás sempre bem-vindo!</p><p>Um abraço amigo dos Carraças,</p>");
$templateCache.put("app/registrations/states/payment.html","<div ng-if=\"vm.registration.state == 0 && vm.registration.interest_confirmed==1 && !vm.registration.onhold==1\"><h3>Obrigada por teres confirmado o teu interesse no campo.</h3><p>O ID da tua família é o <strong>{{ vm.registration.sibling_code }}</strong> . Se tiveres irmãos que também tenham entrado num campo e queiram confirmar o seu interesse, diz-lhes que introduzam este ID. Só assim poderão usufruir de um desconto no preço do campo.</p><p>Para garantires a tua vaga, falta apenas pagares, usando os seguintes códigos:</p><dl class=dl-horizontal><dt>Entidade:</dt><dd>{{ vm.registration.reference.data.entity }}</dd><dt>Referência:</dt><dd>{{ vm.registration.reference.data.reference }}</dd><dt>Valor:</dt><dd>{{ vm.registration.reference.data.value }} €</dd><dt>Data de validade:</dt><dd>{{ vm.registration.reference.data.expiration_date }}</dd></dl><p>Se deixares passar o prazo de pagamento perdes a vaga e a tua inscrição será cancelada.</p></div><p>Não queremos que ninguém deixe de fazer campo por dificuldades financeiras. Fala connosco para: <a href=mailto:pulgas.carracas@carracas.pt>pulgas.carracas@carracas.pt</a> se for esse o caso.</p>");}]);